export default __webpack_public_path__ + "static/interactive-videos-385071001087a7c4d2cab09e8f582139.png";